// JobCard.js
import React, { useState } from 'react';
import { Box, Flex, VStack, Text, IconButton,Button, Link } from '@chakra-ui/react';
import { FaBuilding, FaHeart, FaCheckCircle, FaShareAlt } from 'react-icons/fa';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const JobSuggestionCard = ({ jobTitle, company, location, isFeatured, timeAgo, date, shareLink, category, vacancies, onClick }) => {
  const [isFavorited, setIsFavorited] = useState(false);

  const handleFavoriteClick = () => {
    setIsFavorited(!isFavorited);
  };

  const handleShareClick = () => {
    const customUrl = `https://custom.url/${shareLink}`; // Create your custom URL here
    navigator.clipboard.writeText(customUrl).then(() => {
      toast.success('Link copied to clipboard!', {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }).catch(err => {
      console.error('Failed to copy: ', err);
    });
  };

  return (
    <>
      <Box
        borderWidth="1px"
        borderRadius="lg"
        overflow="hidden"
        p={4}
        mb={4}
        boxShadow="md"
        _hover={{ boxShadow: 'lg', transform: 'scale(1.02)' }}
        transition="all 0.3s ease-in-out"
        height="200px"
        position="relative"
        onClick={onClick}
        cursor="pointer"
      >
        <Flex align="center" justify="space-between">
          <Flex align="flex-start">
            <Box as={FaBuilding} boxSize={10} mr={4} color="gray.500" />
            <VStack align="start" spacing={1}>
              <Text fontWeight="bold" fontSize="lg" fontFamily="body">
                {jobTitle}
              </Text>
              <Link href={company}><Text fontSize="sm" color="gray.500" fontFamily="body">
                {company}
              </Text></Link>
              <Text fontSize="sm" color="gray.500" fontFamily="body">
                {location}
              </Text>
              <Text fontSize="sm" color="gray.500" mt={2} fontFamily="body">
                {timeAgo || date}
              </Text>
            </VStack>
          </Flex>
          <Flex align="center" position="absolute" top={2} right={2}>
            {isFeatured && (
              <FaCheckCircle
                style={{
                  color: 'blue', // Blue color for the tick
                  width: '24px', // Increase width
                  height: '24px', // Increase height
                  marginRight: '8px', // Space between tick and heart
                  paddingTop: '6px', // Add more padding top
                  paddingLeft: '6px', // Add more padding left
                }}
              />
            )}
            <IconButton
              aria-label="Share job"
              icon={<FaShareAlt
                  style={{
                      stroke: 'black', // Darker outline color
                      strokeWidth: '8px', // Thicker outline
                      width: '26px', // Increase width
                      height: '24px', // Increase height
                      paddingTop: '5px', // Add more padding top
                      paddingLeft: '3px', // Add more padding left
                      color: 'black',
                    }}
              />}
              variant="unstyled"
              onClick={handleShareClick}
              _hover={{ transform: 'scale(1.2)', background: 'none' }}
              _active={{ transform: 'scale(1.1)', background: 'none' }}
              transition="transform 0.2s ease-in-out"
              boxSize={8}
              mr={2} // Add margin to separate from the heart icon
            />
            <IconButton
              aria-label="Save job"
              icon={
                <FaHeart
                  style={{
                    stroke: 'black', // Darker outline color
                    strokeWidth: '8px', // Thicker outline
                    fill: isFavorited ? 'red' : 'none', // Fill color when favorited
                    width: '26px', // Increase width
                    height: '26px', // Increase height
                    paddingTop: '6px', // Add more padding top
                    paddingLeft: '3px', // Add more padding left
                  }}
                />
              }
              variant="unstyled"
              onClick={handleFavoriteClick}
              _hover={{ transform: 'scale(1.2)', background: 'none' }} // Remove background on hover
              _active={{ transform: 'scale(1.1)', background: 'none' }} // Remove background on active
              transition="transform 0.2s ease-in-out"
              boxSize={8} // Increase the size
            />
          </Flex>
        </Flex>
        <Button
          size="xs"
          color="red.400"
          variant="solid"
          position="absolute"
          bottom={2}
          left={2}
          bg="red.100"
          sx={{
            fontSize: '0.75rem', // Ensure the font size matches 'xs'
            padding: '0.25rem 0.5rem', // Adjust padding for 'xs'
          }}
        >{vacancies}  vacancies
        </Button>
      </Box>
      <ToastContainer />
    </>
  );
};

export default JobSuggestionCard;